import PageHero from "./PageHero";
import CallToAction from "./callToAction";
import heroImage from "../assets/construction3.png";
import passportImage from "../assets/passport.jpg";
import sade from "../assets/sade.jpeg";
import gumbo from "../assets/gumbo.jpeg"

const values = [
  "Detailed schedules and resource plans",
  "Clear communication with project stakeholders",
  "Progress tracking and timely correction of deviations",
  "Close supervision for quality and value for money",
  "Timely project completion and commissioning",
];

const leaders = [
  {
    name: "Yusuph Juma Gumbo",
    image: gumbo,
    role: "Managing Director",
    qualification: "Professional Engineer (PE 5904)",
    experience: "11 years general experience",
    positionExperience: "9 years in proposed position",
  },
  {
    name: "Mganguzi Fadhil Sade",
    image: sade,
    role: "Technical Director",
    qualification: "Professional Engineer (PE 5966)",
    experience: "11 years general experience",
    positionExperience: "9 years in proposed position",
  },
];

const organizationLevels = {
  administrative: [
    {
      title: "Accountant",
      child: "Cashier",
    },
    {
      title: "Procurement Officer",
      child: "Store Keeper",
    },
  ],
  operations: [
    "Project Engineer",
    "Site Foremen",
    "Head of Gangs",
    "Work Force",
  ],
};

const policies = [
  {
    title: "Anti-Bribery Policy",
    text:
      "SMART TGM Limited supports fair, competitive, and transparent bidding. The company does not offer or facilitate improper inducements or rewards to public officers, relations, business associates, agents, consultants, subcontractors, or suppliers.",
    points: [
      "No bribes or improper inducements in connection with bids or contracts",
      "No authorization for employees or independent agents to act improperly",
      "Disclosure of relevant bid-related payments where required",
      "Instruction to employees and representatives to comply with Tanzania laws",
    ],
  },
  {
    title: "Health, Safety and Welfare Policy",
    text:
      "The company prioritizes the health, safety, and welfare of employees and people affected by its work, while maintaining safe working environments and meeting relevant legislative requirements.",
    points: [
      "Safeguard employees while at work",
      "Protect people affected by company undertakings",
      "Meet relevant health and safety requirements",
      "Arrange operations to support policy compliance",
    ],
  },
  {
    title: "Operation of the Safety Policy",
    text:
      "SMART TGM Limited keeps safety responsibilities active across management levels, project planning, training, workplace coordination, and policy review.",
    points: [
      "Maintain management responsibility for health and safety",
      "Provide suitable safety training and instructions",
      "Include accident prevention in relevant training programs",
      "Plan work to reduce injuries, industrial diseases, pollution, and waste",
      "Coordinate safety matters with other employers on shared sites",
    ],
  },
  {
    title: "Accident Prevention Policy",
    text:
      "Before work starts, SMART TGM Limited expects staff and contractors to comply with health and safety legislation, company policy, site rules, risk assessments, method statements, and protective equipment requirements.",
    points: [
      "Provide training before project work begins",
      "Prepare risk assessments and method statements",
      "Procure personal protective equipment during mobilization",
      "Keep site access controlled with safety equipment requirements",
      "Maintain trained first aiders and suitable first aid kits",
    ],
  },
];

function Overview() {
  return (
    <>
      <PageHero
        eyebrow="About SMART TGM"
        title="A civil and building contractor built around assured execution."
        text="SMART TGM Limited is a general works contractor in Tanzania specializing in civil and building works for small to medium-size projects."
        image={heroImage}
      />

      <section className="tgm-section tgm-about-overview" data-aos="fade-up">
        <div className="container">
          <div className="tgm-about-layout">
            <div className="tgm-about-copy">
              <p className="tgm-section-kicker">Who We Are</p>
              <h2>
                We coordinate people, trades, and technical decisions so projects
                keep moving.
              </h2>
              <p>
                The company plays the role of contractor for civil works,
                residential buildings, commercial buildings, schools, health
                facilities, irrigation works, transportation facilities, and
                related infrastructure projects.
              </p>
              <p>
                SMART TGM Limited also provides project management services,
                engineering solutions, and design inputs as value-added support
                to clients who need confidence during planning and execution.
              </p>
            </div>

            <div className="tgm-about-panel">
              <span>Objective</span>
              <h3>An assured client experience.</h3>
              <p>
                Our objective is to give clients an assured experience through
                clear communication, follow-up procedures, and disciplined
                planning that keeps client objectives as the priority.
              </p>
            </div>
          </div>

          <div className="tgm-mission-grid">
            <article>
              <span>Mission</span>
              <h3>Deliver construction works with reliable coordination.</h3>
              <p>
                To plan, execute, supervise, and commission civil and building
                projects with clear communication, quality control, and value for
                money.
              </p>
            </article>
            <article>
              <span>Vision</span>
              <h3>Become a trusted contractor for durable built environments.</h3>
              <p>
                To be recognized for dependable project delivery, technical
                discipline, and long-term client confidence across Tanzania.
              </p>
            </article>
          </div>

          <div className="tgm-values-strip">
            {values.map((value, index) => (
              <div key={value}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <p>{value}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
}

function Team() {
  return (
    <>
      <PageHero
        eyebrow="Team"
        title="Leadership with technical and project delivery experience."
        text="SMART TGM Limited is led by professional engineers who bring planning, supervision, and execution discipline to the construction process."
        image={heroImage}
      />

      <section className="tgm-section tgm-team-page" data-aos="fade-up">
        <div className="container">
          <div className="tgm-section-head">
            <div>
              <p className="tgm-section-kicker">Organization Chart</p>
              <h2>Clear leadership lines for project control.</h2>
            </div>
            <p>
              The company structure separates administration and project
              delivery while keeping both streams accountable to the directors.
            </p>
          </div>

          <div className="tgm-org-chart-card" data-aos="fade-up">
            <h2>Organization Chart</h2>
            <div className="tgm-org-node tgm-org-node-top">Directors</div>

            <div className="tgm-org-main-split">
              <div className="tgm-org-branch tgm-org-branch-admin">
                <div className="tgm-org-node tgm-org-node-wide">
                  Business Development Manager
                </div>

                <div className="tgm-org-admin-pair">
                  {organizationLevels.administrative.map((item) => (
                    <div className="tgm-org-stack" key={item.title}>
                      <div className="tgm-org-node">{item.title}</div>
                      <div className="tgm-org-node">{item.child}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="tgm-org-branch tgm-org-branch-site">
                {organizationLevels.operations.map((item) => (
                  <div className="tgm-org-node" key={item}>
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="tgm-section-head tgm-team-leaders-head">
            <div>
              <p className="tgm-section-kicker">Key Personnel</p>
            </div>
          </div>

          <div className="tgm-org-tree">
            {leaders.map((leader, index) => (
              <article
                className="tgm-team-card tgm-team-card-large"
                key={leader.name}
                data-aos="fade-up"
                data-aos-delay={index * 80}
              >
                <div className="tgm-team-card-image">
                  <img src={leader.image} alt={leader.name} />
                </div>
                <h3>{leader.name}</h3>
                <span>{leader.role}</span>
                <p>{leader.qualification}</p>
                <p>{leader.experience}</p>
                <p>{leader.positionExperience}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
}

function Policies() {
  return (
    <>
      <PageHero
        eyebrow="Policies"
        title="Company policies that support responsible construction delivery."
        text="SMART TGM Limited documents its commitments around anti-bribery, health, safety, welfare, and accident prevention."
        image={heroImage}
      />

      <section className="tgm-section tgm-policies-page" data-aos="fade-up">
        <div className="container">
          <div className="tgm-policy-grid">
            {policies.map((policy, index) => (
              <article
                className="tgm-policy-card"
                key={policy.title}
                data-aos="fade-up"
                data-aos-delay={index * 70}
              >
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h3>{policy.title}</h3>
                <p>{policy.text}</p>
                <ul>
                  {policy.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
}

export default function AboutUsContent(props) {
  const { section = "overview" } = props;

  if (section === "team") {
    return <Team />;
  }

  if (section === "policies") {
    return <Policies />;
  }

  return <Overview />;
}
